import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const text: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
};

export const count: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  color: (p) => p.palette.primary[500],
};
